module.exports = __webpack_public_path__ + "common/icon-document-fill-f2ca66172cb0a3c206b11fc060198853.svg";